import { useEffect, useRef } from 'react'

import {
  SCROLL_CONTENT_CLASS_NAME,
  SCROLL_KEYS,
} from '../../../../constants/common'
import {
  EVENT_NAME_KEY_DOWN,
  EVENT_NAME_SCROLL,
  EVENT_NAME_TOUCH_MOVE,
  EVENT_NAME_WHEEL,
} from '../../../../constants/event'

import { isEditableElement } from './useSelectDropdownScrollDismiss.utils'

// hide custom select dropdown on only user scroll
export function useSelectDropdownScrollDismiss({
  scrollListener,
  wrapperRef,
  onCloseMenu,
}) {
  const userScrollIntentRef = useRef(false)

  function handleScroll(event) {
    if (
      event.target.classList?.contains(SCROLL_CONTENT_CLASS_NAME) ||
      event.target.value || // if input value exceed max width then scroll action fires, in this case we shoudn't close dropdown
      !scrollListener
    ) {
      userScrollIntentRef.current = false

      return
    }

    if (!userScrollIntentRef.current) {
      return
    }

    userScrollIntentRef.current = false
    onCloseMenu()
  }

  function markUserScrollIntent() {
    userScrollIntentRef.current = true
  }

  function handleKeyDown(event) {
    if (
      !SCROLL_KEYS.has(event.key) ||
      userScrollIntentRef.current ||
      isEditableElement(event.target) ||
      wrapperRef.current?.contains(event.target)
    ) {
      return
    }

    userScrollIntentRef.current = true
  }

  useEffect(() => {
    window.addEventListener(EVENT_NAME_WHEEL, markUserScrollIntent, true)
    window.addEventListener(EVENT_NAME_TOUCH_MOVE, markUserScrollIntent, true)
    window.addEventListener(EVENT_NAME_KEY_DOWN, handleKeyDown, true)

    return () => {
      window.removeEventListener(EVENT_NAME_WHEEL, markUserScrollIntent, true)
      window.removeEventListener(
        EVENT_NAME_TOUCH_MOVE,
        markUserScrollIntent,
        true
      )
      window.removeEventListener(EVENT_NAME_KEY_DOWN, handleKeyDown, true)
    }
  }, [])

  useEffect(() => {
    window.addEventListener(EVENT_NAME_SCROLL, handleScroll, true)

    return function cleanup() {
      window.removeEventListener(EVENT_NAME_SCROLL, handleScroll, true)
    }
  }, [])
}
